<template>
  <EcsContextMenuList ref="rootMenu" />
</template>

<script>
import EcsContextMenuList from '@/components/ecs-context-menu/EcsContextMenuList';

export default {
  name: 'EcsContextMenu',

  components: {
    EcsContextMenuList
  },

  props: {
    xOffset: {
      type: Number,
      default: 3
    }
  },

  created() {
    this.$root.$on('open-context-menu', this.openContextMenu);
  },

  beforeDestroy() {
    this.$root.$off('open-context-menu', this.openContextMenu);
  },

  methods: {
    openContextMenu({ menu, position }) {
      this.$refs.rootMenu.open(menu, position);
    }
  }
};
</script>
